import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';

export default function Warning({ text }) {
  return (
    <p className="msg warning">
      <FaExclamationTriangle /> {text}
    </p>
  );
}

Warning.defaultProps = {
  text: 'Warning!'
};
